import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const integrationsSquareAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.IntegrationsView, Permission.IntegrationsModify],
  warehouseFeatureToggles: FeatureToggle.integrationSquare,
}
